import React from 'react'
import heroAsideImg from '@/assets/images/hero-aside.png'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

import s from './styles.module.scss'

const HeroAside = () => {
  const items = [
    'Agenda de turnos online',
    'Recordatorios masivos por WhatsApp',
    'Historial y datos de cada paciente, ¡Sin papeles!',
    'Administración contable',
    'Sitio web personalizado',
    'y más...',
  ]
  return (
    <section className={s.leftSectionContainer}>
      <header className={s.header}>
        <p className={s.pTitle}>Organizá tu centro de salud y belleza en un solo lugar</p>
        <h2 className={s.mainTitle}>Digitalizá tu gestión con Calu</h2>
      </header>

      <div className={s.imgContainer}>
        <img src={heroAsideImg} alt="" className={s.img} />
      </div>
      <section className={s.featureContainer}>
        <h3 className={s.featuresTitle}>¿Que podés hacer con Calu?</h3>

        <ul className={s.featuresList}>
          {items.map((item, index) => (
            <li key={index} className={s.listItem}>
              <CheckCircleIcon className={s.checkCircleIcon} />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </section>
      <p className={s.trustedText}>
        Más de <b>5000 profesionales</b> confían en nosotros
      </p>
      <p className={s.helpText}>
        <span>¿Necesitas ayuda?</span>{' '}
        <a href="https://wa.link/bf6flo" target="_blank" rel="noopener noreferrer" className={s.tagA}>
          Contactános
        </a>
      </p>
    </section>
  )
}

export default HeroAside
